import { render, staticRenderFns } from "./procedure3.vue?vue&type=template&id=ce041548&scoped=true"
import script from "./procedure3.vue?vue&type=script&lang=js"
export * from "./procedure3.vue?vue&type=script&lang=js"
import style0 from "./procedure3.vue?vue&type=style&index=0&id=ce041548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce041548",
  null
  
)

export default component.exports